export default {
  Holiday2019: {
    whitepaperNameForEvents: 'whitepaper-template',
    fileName: 'mikmak-whitepaper.pdf',
    heading: 'MikMak’s 2019 Holiday eCommerce Guide',
    img: 'holiday-2019-b',
    subheading: 'Shoppers spent $120B online in the U.S. during the 2018 holiday season, and analysts predict that this 2019 holiday season will see continued growth. MikMak put together this guide to help brand marketers make smarter decisions across their creative, media and merchandise investments this holiday season.<br><br>You\'ll learn when in the holiday calendar MikMak sees the highest eCommerce conversion rates, which media channels yield the best results, and creative best practices by product subcategories. New for 2019, you\'ll also learn how to quickly grow - and gain more control over - your brand presence on Amazon.<br><br>Download MikMak’s 2019 Holiday eCommerce Guide by completing the form below.',
    buttonText: 'Download the Guide',
    messageForForm: 'Lead completed 2019 Holiday eCommerce Guide Form',
    link: 'https://bit.ly/mikmak-holiday-2019',
    videoLink: 'https://bit.ly/MikMak-Holiday-Webinar'
  }
}



// WEBPACK FOOTER //
// ./client/store/imports/Whitepaper.js